import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';

export const getFeedbackList = async (page, dataPerPage, searchValue) => {
  let responseObj = await dataAccess.get(
    `${API_CONSTANTS.FEEDBACK}/list?page=${page}&limit=${dataPerPage}&search=${searchValue}`
  );
  return responseObj;
};

export const createFeedback = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };
  let response = await dataAccess.post(
    `${API_CONSTANTS.FEEDBACK}/add`,
    payload
  );
  return response;
};

export const updateFeedback = async (id, incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.FEEDBACK}/update?feedbackId=${id}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };
  let response = await dataAccess.put(url, payload);
  return response;
};

export const getFeedbackById = async (id) => {
  let url = `${API_CONSTANTS.FEEDBACK}/detail?feedbackId=${id}`;

  let responseObj = await dataAccess.get(url);
  return responseObj;
};

export const deleteFeedback = async (id) => {
  let url = `${API_CONSTANTS.FEEDBACK}/delete?feedbackId=${id}`;
  let payload = {
    data: {
      id: id,
    },
  };
  let responseObj = await dataAccess.del(url, payload);
  return responseObj;
};

export async function uploadMedia(file) {
  let formData = new FormData();
  formData.append('image', file);
  let payload = {
    data: formData,
  };

  let responseObj = await dataAccess.upload(
    `${API_CONSTANTS.MEDIA_UPLOAD}`,
    payload
  );

  return responseObj;
}
